import type { VerticalDatumData, VerticalDatumDataTable } from "building-types/columns/columnDatumTypes";
import { RelativeVerticalDatum, VerticalDatumType } from "building-types/datums/datumsTypesEnum";

export const defaultRelativeVerticalDatumData: VerticalDatumData = {
  type: VerticalDatumType.RELATIVE,
  topDatumId: RelativeVerticalDatum.TOP_OF_WALL_PLATE_HOST,
  bottomDatumId: RelativeVerticalDatum.TOP_OF_FF_HOST,
  topOffset: undefined,
  bottomOffset: undefined,
};

export const defaultRelativeVerticalDatumDataStairSystem: VerticalDatumData = {
  type: VerticalDatumType.RELATIVE,
  topDatumId: RelativeVerticalDatum.STAIR_SYSTEM,
  bottomDatumId: RelativeVerticalDatum.BOTTOM_OF_STAIR_SYSTEM_HOST,
  topOffset: undefined,
  bottomOffset: undefined,
};

export const defaultAbsoluteVerticalDatumData: VerticalDatumData = {
  type: VerticalDatumType.ABSOLUTE,
  topDatumId: undefined,
  bottomDatumId: undefined,
  topOffset: undefined,
  bottomOffset: undefined,
};

export const defaultVerticalDatumsInternal = {
  ["defaultRelativeVerticalDatumData"]: defaultRelativeVerticalDatumData,
  ["defaultAbsoluteVerticalDatumData"]: defaultAbsoluteVerticalDatumData,
} as const;

export type DefaultVerticalDatumDataId = keyof typeof defaultVerticalDatumsInternal;
export const defaultVerticalDatumDataInternalIds: VerticalDatumDataTable = defaultVerticalDatumsInternal;
